import React from "react";
import translate from "../../Utils/translate";
import BasePrompt from "./BasePrompt";

export default function ErrorPrompt({ prompt }) {
  const title = prompt?.title ?? translate("errors.unexpected_error");
  return (
    <BasePrompt className="bg-red-200 text-neutral-600 border border-red-500" promptId={prompt?.id}>
      <h2>
        {title} {prompt?.status}
      </h2>
      <p>{prompt?.serverMessage}</p>
    </BasePrompt>
  );
}
